import { ExternalLink } from "lucide-react";
import React from "react";
import { Button } from "../ui/button";

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: Parameters<typeof Button>[0]["variant"];
}

export const QuickStartLink = ({ variant, ...htmlAttributes }: Props) => {
  return (
    <a
      href="https://www.numerous.com/docs/quick-start"
      target="_blank"
      rel="noreferrer"
      {...htmlAttributes}
    >
      <Button variant={variant} type="button">
        Learn how to deploy apps
        <ExternalLink size={14} className="ml-2" />
      </Button>
    </a>
  );
};
